import { Controller } from "stimulus"
import Sortable from "sortablejs"

export default class extends Controller {
  connect() {
    var nestedSortables = $(".nested-sortable");
    for (var element of nestedSortables) {
      new Sortable(element, {
        group: 'nested',
        animation: 150,
        fallbackOnBody: true,
        swapThreshold: 0.65,
        dragoverBubble: true,
        handle: ".my-handle",
        onEnd: this.end.bind(this),
        onMove: function(evt) {
          $("div").removeClass("highlight-drop-area");
          $(evt.to).addClass("highlight-drop-area");
        }
      });
    }
  }

  end(event) {
    var group_id = $(event.to).parent().data("group");
    var list_id = event.item.dataset.id;
    var data = { list_id: list_id };
    if (group_id != null) data["list_group_id"] = group_id;
    $.ajax({
      method: "POST",
      url: "/list_groups/manage_group",
      data: data
    });
    $("div").removeClass("highlight-drop-area");
  }

  edit_group_name(event) {
    var span = $(event.target).text();
    var html = $('<input type="text" class="form-control col-md-4 ml-2 d-inline-block" data-action="blur->list-groups#update_group_name keydown->list-groups#update_group_name" autofocus>');
    html.val(span);
    $(event.target).before(html);
    $(event.target).remove();

  }

  update_group_name(event) {
    var group_id = $(event.target).parent().data("group");
    var group_name = $(event.target).val();
    if(group_name !== "" && (event.type === 'blur' || event.keyCode === 13)) {
      var html = $('<span data-action="click->list-groups#edit_group_name"></span>');
      html.text(group_name);
      $(event.target).val('');
      $(event.target).before(html);
      $(event.target).remove();
      $.ajax({
        method: "PUT",
        url: "/list_groups/" + group_id,
        data: { list_group: { name: group_name } }
      });
    }
  }
}